export const rootPageLayoutByVariant = {
  desktop: {
    header: {
      buttonFlexGap: 40,
      innerFlexGap: 48,
      left: 0,
      position: 'absolute',
      px: 156,
      right: 0,
      zIndex: 99,
    },
  },
  laptop: {
    header: {
      buttonFlexGap: 24,
      innerFlexGap: 36,
      left: 0,
      mt: 21,
      position: 'absolute',
      px: 24,
      right: 0,
      zIndex: 99,
    },
    linksGap: 24,
  },
  mobile: {
    header: {
      buttonFlexGap: 24,
      innerFlexGap: 24,
      left: 0,
      linksGap: 32,
      mt: 21,
      position: 'absolute',
      px: 16,
      right: 0,
      socialButtonSize: 44,
      zIndex: 99,
    },
  },
  tablet: {
    header: {
      buttonFlexGap: 24,
      innerFlexGap: 24,
      left: 0,
      linksGap: 24,
      mt: 21,
      position: 'absolute',
      px: 24,
      right: 0,
      socialButtonSize: 44,
      zIndex: 99,
    },
  },
};
